import { FDTableColumn } from "types/app";
import { host, instance, alertType } from "settings/filters";

export const ALL_OBJECTS_LABEL = "All current and future objects";

export const filters = [host, instance, alertType];

export const profileDetailsColumns: Array<FDTableColumn> = [
  { field: "name", name: "Profile Name", dataType: "string" },
  { field: "description", name: "Description", dataType: "string" },
  {
    field: "isSystemProfile",
    name: "System Profile",
    render: (isSystem: boolean) => (isSystem ? "Yes" : "No"),
    dataType: "string",
  },
  { field: "timeZone", name: "Time Zone", dataType: "string" },
  { field: "readOnlyReason", name: "Read Only Reason", dataType: "string" },
];

export const resourceAssignmentColumns: Array<FDTableColumn> = [
  { field: "resourceName", name: "Resource Name", dataType: "string" },
];

export const alertTypeAssignmentColumns: Array<FDTableColumn> = [
  { field: "name", name: "Alert Type Name", dataType: "string" },
  { field: "severityTypeName", name: "Severity", dataType: "string" },
  { field: "thresholdName", name: "Threshold", dataType: "string" },
];

export const notificationChannelMappingColumns: Array<FDTableColumn> = [
  { field: "name", name: "Channel Name", dataType: "string" },
  {
    field: "severityAssignments",
    name: "Severity Assignments",
    dataType: "string",
    renderExcel: (assignments) => assignments?.map((a: any) => a.name).join(", "),
  },
];

export const profilePropertiesColumns: Array<FDTableColumn> = [
  { field: "property", name: "Property", dataType: "string" },
  { field: "value", name: "Value", dataType: "string" },
];

export const activityWindowColumns: Array<FDTableColumn> = [
  { field: "startTime", name: "Start Time", dataType: "string" },
  { field: "endTime", name: "End Time", dataType: "string" },
  {
    field: "daysOfWeek",
    name: "Days of Week",
    dataType: "string",
    renderExcel: (days: string[]) => days?.join(", "),
  },
];

export const SEVERITY_TYPES = new Map([
  [5, "Critical"],
  [3, "Warning"],
  [1, "Information"],
]);

export const SEVERITY_COLORS = {
  Information: "var(--green)",
  Warning: "var(--amber)",
  Critical: "var(--red)",
} as const;

export type SeverityType = keyof typeof SEVERITY_COLORS;

export const PROFILE_STEPS = [
  { number: 1, title: "Profile Details" },
  { number: 2, title: "Assign Resources" },
  { number: 3, title: "Assign Alert Types" },
  { number: 4, title: "Assign Notification Channels" },
];
